import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "moment/locale/fr";
import {
  addCandidateLanguage,
  deleteCandidateLanguage,
  updateCandidateLanguage,
} from "../../../redux/actions/admin/CandidateActions";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";

let LanguageResume = (props) => {
  const {
    languageList,
    addCandidateLanguage,
    deleteCandidateLanguage,
    updateCandidateLanguage,
  } = props;

  const closeDeleteLanguageModal = React.useRef();
  const [
    displayingCandidateLanguageList,
    setDisplayCandidateLanguageList,
  ] = React.useState([]);
  const [showLanguageForm, setShowLanguageForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  const [isLanguageAdding, setIsLanguageAdding] = React.useState(false);
  const [isLanguageUpdating, setIsLanguageUpdating] = React.useState(false);
  const [isLanguageDeletting, setIsLanguageDeletting] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const [languageTodelete, setLanguageTodelete] = React.useState(null);
  const [candidate, setCandidate] = React.useState(null);
  const [newLanguage, setNewLanguage] = React.useState({
    id: "",
    name: "",
    writingLevel: "",
    speakingLevel: "",
  });
  const [languageToUpdate, setLanguageToUpdate] = React.useState({});

  useEffect(() => {
    if (languageList !== null && displayingCandidateLanguageList.length === 0) {
      setDisplayCandidateLanguageList(languageList);
    }
  }, [languageList]);

  const toggleForm = () => {
    setShowLanguageForm(!showLanguageForm);
  };

  const toggleUpdateForm = (language) => {
    setLanguageToUpdate(language);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [language.id]: !prevState[language.id],
    }));
  };

  const handleCreateLanguageSubmit = async () => {
    setIsLanguageAdding(true);
    let language = newLanguage;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    language.candidateId = candidate.id;
    try {
      const data = await addCandidateLanguage(language);
      if (data.success) {
        setDisplayCandidateLanguageList(data.candidate.languages);
        setCandidate(data.candidate);
        clearLanguageForm();
      }
      setIsLanguageAdding(false);
      setPublished(true);
      setShowLanguageForm(false);
    } catch (error) {
      setIsLanguageAdding(false);
    }
  };
  const clearLanguageForm = () => {
    setNewLanguage({
      id: "",
      name: "",
      writingLevel: "",
      speakingLevel: "",
    });
  };
  const handleUpdateLanguageSubmit = () => {
    setIsLanguageUpdating(true);
    let language = languageToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    language.candidateId = candidate.id;

    updateCandidateLanguage(language).then((data) => {
      if (data.success) {
        setDisplayCandidateLanguageList(data.candidate.languages);
        setCandidate(data.candidate);
      }
      setIsLanguageUpdating(false);
      setPublished(false);
      toggleUpdateForm(language);
    });
  };

  const handleDeleteLanguageSubmit = () => {
    setIsLanguageDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateLanguage(candidate?.id, languageTodelete?.id).then(
      (resp) => {
        if (resp.success === true) {
          setDisplayCandidateLanguageList(resp.candidate.languages);
          setCandidate(resp.candidate);
        }
        setLanguageTodelete("");
        closeDeleteLanguageModal.current.click();
        setIsLanguageDeletting(false);
      }
    );
  };

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0 ">
              <h3 className="title mb-0">
                {" "}
                <span>Langues</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button className="btn btn-primary" onClick={toggleForm}>
              Ajouter une Langue
            </button>
          </div>
        </div>
        <div className="row">
          {showLanguageForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div className="bg-light-3">
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label>Nom </label>
                        <input
                          value={newLanguage.name}
                          type="text"
                          className="form-control"
                          id="title"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewLanguage((prevState) => {
                              return { ...prevState, name: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label>Ecrit </label>
                        <input
                          value={newLanguage.writingLevel}
                          type="number"
                          className="form-control"
                          id="writingLevel"
                          min={0}
                          max={10}
                          onChange={(e) => {
                            let val = e.target?.value;
                            val = Math.min(Math.max(val, 0), 10);
                            setNewLanguage((prevState) => {
                              return {
                                ...prevState,
                                writingLevel: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label>Parlé </label>
                        <input
                          value={newLanguage.speakingLevel}
                          type="number"
                          className="form-control"
                          id="speakingLevel"
                          min={0}
                          max={10}
                          onChange={(e) => {
                            let val = e.target?.value;
                            val = Math.min(Math.max(val, 0), 10);
                            setNewLanguage((prevState) => {
                              return {
                                ...prevState,
                                speakingLevel: val,
                              };
                            });
                          }}
                        />
                      </div>

                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateLanguageSubmit}
                          disabled={isLanguageAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isLanguageAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-xl-12 mt-4">
            {displayingCandidateLanguageList?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                {displayingCandidateLanguageList?.map((language, index) => (
                  <div className="jobster-timeline-item" key={index}>
                    <div className="jobster-timeline-info">
                      <div className="dashboard-timeline-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-10">
                                    <span className="text-dark">
                                      <strong>{language.name}</strong>
                                    </span>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-1">
                                            <div className="mt-2">Ecrit:</div>
                                          </div>
                                          <div className="col-11">
                                            <div className="">
                                              <span className="jobster-timeline-time float-right">
                                                {language.writingLevel}%
                                              </span>
                                              <div className="progress mt-0">
                                                <div
                                                  className="progress-bar"
                                                  role="progressbar"
                                                  style={{
                                                    width: `${
                                                      (language.writingLevel /
                                                        10) *
                                                      100
                                                    }%`,
                                                  }}
                                                  aria-valuenow={
                                                    language.writingLevel
                                                  }
                                                  aria-valuemin="0"
                                                  aria-valuemax="10"
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-1">
                                            <div className="mt-2">Parlé:</div>
                                          </div>
                                          <div className="col-11">
                                            <div>
                                              <span className="jobster-timeline-time float-right">
                                                {language.speakingLevel}%
                                              </span>
                                              <div className="progress mt-0">
                                                <div
                                                  className="progress-bar"
                                                  role="progressbar"
                                                  style={{
                                                    width: `${
                                                      (language.speakingLevel /
                                                        10) *
                                                      100
                                                    }%`,
                                                  }}
                                                  aria-valuenow={
                                                    language.speakingLevel
                                                  }
                                                  aria-valuemin="0"
                                                  aria-valuemax="10"
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div className="dashboard-timeline-edit">
                                      <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                        <li className="pr-2">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              toggleUpdateForm(language)
                                            }
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            className="text-danger"
                                            data-toggle="modal"
                                            title=""
                                            data-target="#deleteLanguage"
                                            data-original-title="Delete"
                                          >
                                            <i
                                              className="far fa-trash-alt text-danger"
                                              onClick={() =>
                                                setLanguageTodelete(language)
                                              }
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            {showUpdateForm[language.id] && (
                              <div className="col-12">
                                <div className="my-4">
                                  <div className="bg-light-3 p-4">
                                    <div _lpchecked="1">
                                      <div className="form-row">
                                        <div className="form-group col-md-4">
                                          <label>Nom </label>
                                          <input
                                            value={languageToUpdate.name}
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            onChange={(e) => {
                                              let val = e.target?.value;
                                              setLanguageToUpdate(
                                                (prevState) => {
                                                  return {
                                                    ...prevState,
                                                    name: val,
                                                  };
                                                }
                                              );
                                            }}
                                          />
                                        </div>
                                        <div className="form-group col-md-4">
                                          <label>Ecrit </label>
                                          <input
                                            value={
                                              languageToUpdate.writingLevel
                                            }
                                            type="number"
                                            className="form-control"
                                            id="writingLevel"
                                            min={0}
                                            max={10}
                                            onChange={(e) => {
                                              let val = e.target?.value;
                                              val = Math.min(
                                                Math.max(val, 0),
                                                10
                                              );
                                              setLanguageToUpdate(
                                                (prevState) => {
                                                  return {
                                                    ...prevState,
                                                    writingLevel: val,
                                                  };
                                                }
                                              );
                                            }}
                                          />
                                        </div>
                                        <div className="form-group col-md-4">
                                          <label>Parlé </label>
                                          <input
                                            value={
                                              languageToUpdate.speakingLevel
                                            }
                                            type="number"
                                            className="form-control"
                                            id="speakingLevel"
                                            min={0}
                                            max={10}
                                            onChange={(e) => {
                                              let val = e.target?.value;
                                              val = Math.min(
                                                Math.max(val, 0),
                                                10
                                              );
                                              setLanguageToUpdate(
                                                (prevState) => {
                                                  return {
                                                    ...prevState,
                                                    speakingLevel: val,
                                                  };
                                                }
                                              );
                                            }}
                                          />
                                        </div>

                                        <div className="col-12 mt-4">
                                          <button
                                            className="btn btn-primary"
                                            onClick={handleUpdateLanguageSubmit}
                                            disabled={isLanguageUpdating}
                                            style={{
                                              textAlign: "right",
                                              float: "right",
                                            }}
                                          >
                                            Mettre à jour &nbsp;{" "}
                                            {isLanguageUpdating ? (
                                              <CircularProgress size={15} />
                                            ) : (
                                              <span></span>
                                            )}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteLanguage"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">Suppression d'une langue</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer cette langue:{" "}
                        {languageTodelete?.name}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteLanguageModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteLanguageSubmit}
                    disabled={isLanguageDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isLanguageDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
      </div>
    </React.Fragment>
  );
};

LanguageResume.propTypes = {
  addCandidateLanguage: PropTypes.func.isRequired,
  deleteCandidateLanguage: PropTypes.func.isRequired,
  updateCandidateLanguage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addCandidateLanguage: PropTypes.func.isRequired,
  deleteCandidateLanguage: PropTypes.func.isRequired,
  updateCandidateLanguage: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  addCandidateLanguage,
  deleteCandidateLanguage,
  updateCandidateLanguage,
})(LanguageResume);
